import { FC, FormEvent, useState } from 'react'
import axios from 'axios'
import { ButtonType, showError } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button } from 'app/components'
import { SncrNumeroUsado } from '../core/_models'
import { localizarNumeroSncr } from '../core/_requests'
import { SncrNumerosTabela } from './SncrNumerosTabela'

/** "Em qual receita minha este número foi usado?" — a pergunta que farmácia e Vigilância fazem. */
export const SncrLocalizarNumeroModal: FC = () => {
  const { t } = useT()
  const [numero, setNumero] = useState('')
  const [localizado, setLocalizado] = useState<SncrNumeroUsado | null>(null)
  const [naoEncontrado, setNaoEncontrado] = useState(false)
  const [localizando, setLocalizando] = useState(false)

  const localizar = async (e: FormEvent) => {
    e.preventDefault()
    const buscado = numero.trim()
    if (buscado === '') return
    setLocalizando(true)
    setLocalizado(null)
    setNaoEncontrado(false)
    try {
      setLocalizado(await localizarNumeroSncr(buscado))
    } catch (error) {
      // 404 é resposta, não falha: o número não existe ou é de outro prescritor.
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        setNaoEncontrado(true)
      } else {
        showError(error)
      }
    } finally {
      setLocalizando(false)
    }
  }

  return (
    <form className='d-flex flex-column gap-4' onSubmit={localizar}>
      <p className='text-gray-700 mb-0'>{t('sncr.localizar.info')}</p>

      <div className='d-flex flex-wrap gap-3 align-items-start'>
        <label htmlFor='sncr-localizar' className='visually-hidden'>
          {t('sncr.localizar.rotulo')}
        </label>
        <input
          id='sncr-localizar'
          type='text'
          className='form-control form-control-solid font-monospace'
          style={{ maxWidth: 280 }}
          placeholder={t('sncr.localizar.placeholder')}
          value={numero}
          onChange={(e) => setNumero(e.target.value)}
          autoComplete='off'
          spellCheck={false}
        />
        <Button
          className='btn-primary'
          type={ButtonType.Submit}
          disabled={localizando || numero.trim() === ''}
        >
          {t('sncr.localizar.botao')}
        </Button>
      </div>

      <div role='status' aria-live='polite'>
        {naoEncontrado && (
          <p className='text-gray-700 mb-0'>{t('sncr.localizar.nao_encontrado')}</p>
        )}
        {localizado && <SncrNumerosTabela numeros={[localizado]} />}
      </div>
    </form>
  )
}
